const awsmobile =  {
  "aws_appsync_graphqlEndpoint": "https://jixpde5kena2pk3py6kb36k5c4.appsync-api.us-east-2.amazonaws.com/graphql",
  "aws_appsync_region": "us-east-2",
  "aws_appsync_authenticationType": "API_KEY",
  "aws_appsync_apiKey": "da2-eww5fx3hzfe4hawgcerbx6vyty",
};

export default awsmobile;